<template>
  <div class="col-lg-6 mb-4">
    <router-link class="card text-reset text-decoration-none _hover h-100" :to="RedirectTo">
      <div class="media p-4">
        <i
          class="course-img mr-3 _2x rounded-circle d-none d-md-block"
          :style="{ backgroundImage: `url('${Book.bookIcon}')` }"
        ></i>
        <div class="media-body align-self-center d-flex flex-column">
          <h4>{{ Book.bookName }}</h4>
          <p class="m b-0">{{ Book.groupName }}</p>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'Scheme',

  props: {
    Book: Object,
    RedirectTo: String,
  },
};
</script>
<style scoped type="text/css">
.ofGray {
  filter: grayscale(100%);
  filter: gray;
  opacity: 0.4;
}
</style>
